import { Provider } from './Provider';

const urlFallback = require('./url-fallback.json');

export class UrlProvider implements Provider {
    private _defaultApUrl: string;
    private _defaultDomainUrl: string;
    private _overrideApUrl?: string;
    private _overrideDomainUrl?: string;

    constructor() {
        this._defaultApUrl = '';
        this._defaultDomainUrl = '';

        // Init variables
        this.init();
    }

    init() {
        // @ts-ignore
        this._defaultApUrl = process.env.REACT_APP_AP_URL;
        // @ts-ignore
        this._defaultDomainUrl = process.env.REACT_APP_DOMAIN_URL;

        if (!this._defaultApUrl) {
            console.error(
                'ERROR: Unable to load default domain url or ap url. Fallback urls will be used');
            // Caricamento url fallback
            this._defaultApUrl = urlFallback.apUrl;
        }

        if (!this._defaultDomainUrl) {
            console.error(
                'ERROR: Unable to load default domain url or ap url. Fallback urls will be used');
            // Caricamento url fallback
            this._defaultDomainUrl = urlFallback.domainUrl;
        }

        console.info(`Successfully loaded urls: ${this._defaultApUrl}`);
    }

    /**
     * Restituisce lo url da utilizzare per raggiungere il server di autenticazione
     * richieste http
     */
    getApUrl(): string {
        return this._overrideApUrl || this._defaultApUrl;
    }

    /**
     * Imposta un valore di override dello url di autenticazione
     * @param value
     */
    overrideApUrl(value: string) {
        this._overrideApUrl = value;
    }

    /**
     * Restituisce lo url da utilizzare per raggiungere il server di dominio
     * richieste http
     */
    getDomainUrl(): string {
        return this._overrideDomainUrl || this._defaultDomainUrl;
    }

    /**
     * Imposta un valore di override dello url di dominio
     * @param value
     */
    overrideDomainUrl(value: string) {
        this._overrideDomainUrl = value;
    }
}